// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__7nARz","info":"UpdateTermsInfo_info__14OTW"};